module.exports = __webpack_public_path__ + "media/thanos_snap_sound.b746c7d7.mp3";